// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_eR","advertDetailContactItem__link":"c-n_eS"};